(function () {
  if (window.Shopify && Shopify.designMode) return; // keep the theme editor usable
  var sel = 'img, picture, video, .card-gallery';
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest(sel)) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest('img')) e.preventDefault();
  });
})();
